import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ e('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#6DA544" d="M20 0c-3.536 0-6.857.919-9.74 2.53v34.94A19.908 19.908 0 0 0 20 40c11.046 0 20-8.954 20-20S31.046 0 20 0Z"></path><path fill="#F0F0F0" d="M10.32 2.496a20.043 20.043 0 0 0-3.178 2.186L22.459 20 7.142 35.318a20.05 20.05 0 0 0 3.178 2.186L40 20 10.32 2.496Z"></path><path fill="#FFDA44" d="M8.63 3.545c-.61.423-1.195.877-1.753 1.363L20 20 6.876 35.092c.559.486 1.144.94 1.754 1.362L36.576 20 8.63 3.545Z"></path><path fill="#000" d="M7.142 4.682a20.14 20.14 0 0 0-1.284 1.176L18.26 20 5.858 34.142c.41.41.84.802 1.284 1.176L22.459 20 7.142 4.682Z"></path><path fill="#D80027" d="M5.858 5.858c-7.81 7.81-7.81 20.474 0 28.284L20 20 5.858 5.858Z"></path>', 6), o = [
  l
];
function h(p, n) {
  return t(), a("svg", c, [...o]);
}
const d = { render: h };
export {
  d as default,
  h as render
};
